module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page07"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle2"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#fm_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vacuum Diagrams")]), _vm._v(" is a novel based on the short stories which—together with my novels "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Raft")]), _vm._v(" (1991), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Timelike Infinity")]), _vm._v(" (1992), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Flux")]), _vm._v(" (1993), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ring")]), _vm._v(" (1994)—comprise my “Xeelee Sequence” Future History.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The stories, written between 1987 and 1995, have been revised for this edition; a new timeline is appended; references to the novels are included as footnotes, and a new short story (“Eve”) has been included as bridging material.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Of the twenty-two stories included here, four were first published in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Isaac Asimov’s Science Fiction Magazine,")]), _vm._v(" one in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("SF Age,")]), _vm._v(" one in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Writers Of The Future")]), _vm._v(" anthology, and eight in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Interzone")]), _vm._v(". Two (“Lieserl” and “Cilia-of-Gold”) have been included in annual "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Legend Year’s Best SF")]), _vm._v(" collections, edited by Gardner Dozois. The other stories mostly appeared in small-press magazines and, while fans are aware of the pieces, they have been largely unavailable before this collection.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de328e3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/for.vue
// module id = 69
// module chunks = 0